import React from "react";
import { FloatButton, Layout } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import "./Layout.css";
import {
  MainFooter,
  MainHeader,
  RedHeader,
} from "./Component/HeaderFooter/HeaderFooter";
import { Outlet, useLocation } from "react-router";
const { Content } = Layout;

const MainLayout = () => {
  const location = useLocation();

  // Define routes where RedHeader should be used
  const aboutUsHeader = ["/about-us"];
  const ourValueHeader = ["/our-value"];
  const ourBrandsHeader = ["/brands"];
  // const storesHeader = ["/stores"];
  const partnershipHeader = ["/partnership"];
  const isContrast =
    aboutUsHeader.includes(location.pathname) ||
    ourValueHeader.includes(location.pathname) ||
    ourBrandsHeader.includes(location.pathname) ||
    // storesHeader.includes(location.pathname) ||
    partnershipHeader.includes(location.pathname);
  return (
    <Layout>
      {isContrast ? <RedHeader /> : <MainHeader />}
      <Content>
        <div className="content-container carousel-container">
          <Outlet />
          <a
            href="https://wa.me/6285607444174?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20BAS%20Group"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FloatButton
              icon={<WhatsAppOutlined />}
              type="default"
              style={{
                insetInlineEnd: 24,
              }}
            />
          </a>
        </div>
      </Content>
      <MainFooter />
    </Layout>
  );
};
export default MainLayout;
